<span class="userBadge _{{role}}">
    <i class="fa"></i><span [i18n]="'user-type.'+role"></span>
</span>
